import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { GroupMemberInfo } from "../types/gigya";

type AccordianTablePendingItemProps = {
  row: GroupMemberInfo;
  onPropStatusChange: (row: GroupMemberInfo, status: string) => void;
  onPropRoleChange: (row: GroupMemberInfo, role: string) => void;
  remove: () => void;
};
export const AccordionTablePendingItem = (
  props: AccordianTablePendingItemProps,
) => {
  const { row, onPropStatusChange, onPropRoleChange, remove } = props;

  const onStatusChange = (event: SelectChangeEvent, row: GroupMemberInfo) => {
    onPropStatusChange(row, event?.target.value);
  };

  const onRoleChange = (event: SelectChangeEvent, row: GroupMemberInfo) => {
    onPropRoleChange(row, event?.target.value);
  };

  return (
    <div>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span">{`${row.profile.lastName}, ${row.profile.firstName}`}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Select
            sx={{
              boxShadow: "none",
              ".MuiOutlinedInput-notchedOutline": { border: 0 },
              minWidth: 120,
            }}
            id="member-status-id"
            value={row.relationshipData.status}
            label={row.relationshipData.status}
            onChange={(event) => onStatusChange(event, row)}
          >
            <MenuItem value="approved">Approved</MenuItem>
            <MenuItem value="rejected">Rejected</MenuItem>
            <MenuItem value="pending">Pending</MenuItem>
          </Select>
        </AccordionDetails>
        <AccordionDetails>
          <Select
            sx={{
              boxShadow: "none",
              ".MuiOutlinedInput-notchedOutline": { border: 0 },
              minWidth: 120,
            }}
            id="member-role-id"
            value={row.relationshipData.role}
            label={row.relationshipData.role}
            onChange={(event) => onRoleChange(event, row)}
          >
            <MenuItem value="admin">Admin</MenuItem>
            <MenuItem value="employee">Employee</MenuItem>
            <MenuItem value="member">Member</MenuItem>
          </Select>
        </AccordionDetails>
        <AccordionDetails>{row.profile.email}</AccordionDetails>
        <AccordionActions>
          <Button onClick={remove}>Remove</Button>
        </AccordionActions>
      </Accordion>
    </div>
  );
};
